import { SELECIONAR_DATA_IDA } from '../../actions/types'

const initialState = undefined

export default function reducerSelecionarDataIda (state = null, action = initialState) {
  switch (action.type) {
    case SELECIONAR_DATA_IDA: {
      return action.payload;
    }

    default: {
      return state
    }
  }
}
